<template>
  <div class="Do">
    <div class="doMain">
      <div class="doTitle">
<!--        <div class="tit">{{ $t("navbar.index") }}</div>-->
        <div class="sub">
          <li>{{ $t("DAO.join") }}</li>
        </div>
      </div>
      <div class="content">
        <div class="dec">
          <img  src="@/assets/m/Decentralized.png" alt="" />
          <div class="decTitle">{{ $t("home.decentralized") }}</div>
          <div class="intro">{{ $t("home.high") }}</div>
        </div>
        <div class="dec">
          <img  src="@/assets/m/Sustainable-scalability.png" alt="" />
          <div class="decTitle">{{ $t("home.sustainable") }}</div>
          <div class="intro">{{ $t("Do.Dao") }}</div>
        </div>
        <div class="dec">
          <img  src="@/assets/m/Diversified.png" alt="" />
          <div class="decTitle">{{ $t("home.diversified") }}</div>
          <div class="intro">{{ $t("Do.protocol") }}</div>
        </div>
        <div class="dec">
          <img  src="@/assets/m/Dual-protocol.png" alt="" />
          <div class="decTitle">{{ $t("home.dual") }}</div>
          <div class="intro">{{ $t("Do.WASM") }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {

    };
  },
  created() {

  },
  mounted() {

  },
  destroyed() {

  },
  methods: {
  },
};
</script>
<style lang="less">
  .w1352 {
    width: 1200px;
    margin: 0 auto;
  }
  .w1300 {
    width: 67%;
    margin: 0 auto;
  }
  @keyframes showBottom {
    to {
      opacity: 1;
      transform: translateY(0px);
    }
  }
  @keyframes hideBottom {
    to {
      opacity: 0;
      transform: translateY(100px);
    }
  }
</style>
<style lang="less" scoped>
  @keyframes showLeft {
    to {
      opacity: 1;
      transform: translateX(0px);
    }
  }
  @keyframes showRight {
    to {
      opacity: 1;
      transform: translateX(0px);
    }
  }
  @keyframes hideLeft {
    to {
      opacity: 0;
      transform: translateX(-100px);
    }
  }
  @keyframes hideRight {
    to {
      opacity: 0;
      transform: translateX(100px);
    }
  }
  @keyframes scaleUp-animation {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.25);
    }
    100% {
      transform: scale(1);
    }
  }
  @keyframes scaleDown-animation {
    0% {
      transform: scale(1.25);
    }
    50% {
      transform: scale(1);
    }
    100% {
      transform: scale(1.25);
    }
  }
  .scale {
  }
  .scale :hover {
    transform: rotate(7deg);
    -ms-transform: rotate(7deg); /* IE 9 */
    -moz-transform: rotate(7deg); /* Firefox */
    -webkit-transform: rotate(7deg); /* Safari 和 Chrome */
    -o-transform: rotate(7deg); /* Opera */
    color: red;
  }
  .Do {
    text-align: center;
      doMain{
        text-align: center;
    }
  }
  li{
    list-style:none;
  }
  .content{
    display: inline-block;
    margin-top: 120px;
  }
  .tit {
    margin-bottom: 20px;
    /*font-size: 30px;*/
    font-size: 30px;
    font-family: Poppins-Medium, Poppins;
    font-weight: 500;
    color: #000000;
    line-height: 35px;
  }
  .sub {
    margin: 0 auto;
    width: 464px;
    font-size: 64px;
    font-family: Poppins-Black, Poppins;
    font-weight: 900;
    color: #000000;
    line-height: 83px;
    text-align: center;
  }
  .dec{
    width: 650px;
    margin-bottom: 80px;
    opacity: 1;
    text-align: center;
    img{
      width: 247px;
      height: 160px;
    }
    .decTitle{
      /*font-size: 18px;*/

      font-size: 32px;
      font-family: Poppins-SemiBold, Poppins;
      font-weight: 600;
      color: #1A1A2C;
      line-height: 31px;
      -webkit-background-clip: text;
    }
    .intro{
      margin-top: 30px;
      font-family: PingFang SC;
      -webkit-background-clip: text;
      font-size: 28px;
      font-weight: 500;
      color: #61666B;
      line-height: 46px;
    }
  }
  .dec:hover{
    background:#ffffff;
  }

</style>
